import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import { useAuthStore } from "@/store/authStore";
import { demoPartnerDashboard } from "@/data/demoData";
import { unwrapApiObject } from "@/lib/api-response";

export function usePartnerDashboard() {
  const { user } = useAuthStore();

  return useQuery({
    queryKey: ["partner-dashboard"],
    queryFn: async () => {
      if (user?.isDemo) {
        return demoPartnerDashboard;
      }
      try {
        const res = await apiClient.get("/partners/me/dashboard");
        return unwrapApiObject(res, null as any);
      } catch {
        return null;
      }
    },
  });
}
